import Accordion from "react-bootstrap/Accordion";
import AccordionCat from "./AccordionCat";
import { useState } from "react";
export default function CatList({ catListData }) {
  const [activeKey, setActiveKey] = useState(-1);
  return (
    <>
      <div className="mt-3 ">
        <h5>لیست دسته بندی</h5>
        <Accordion onSelect={(e) => setActiveKey(e)} defaultActiveKey="0">
          {catListData.map((c, i) => {
            return (
              <AccordionCat
                index={i}
                title={c.info.title}
                bodyItem={c.sub_products}
                activeKey={activeKey}
              />
            );
          })}
        </Accordion>
      </div>
    </>
  );
}
